// lodash's omit method recreated, removes keys from an object
export function omit<T extends object, K extends keyof T>(
  obj: T,
  keysToOmit: K[]
): Omit<T, K> {
  const result = {} as Omit<T, K>;

  (Object.keys(obj) as Array<keyof T>).forEach((key) => {
    if (!keysToOmit.includes(key as K)) {
      (result as any)[key] = obj[key];
    }
  });

  return result;
}
